class Shape { }
export default Shape;